module.exports = __webpack_public_path__ + "img/kleisma4m.7d6c837a.webp";